import { Component, h } from '@stencil/core';
import trackEvent from '../../utils/analytics';

@Component({
  tag: 'ci-template',
  styleUrl: 'ci-template.scss',
})
export class ciTemplate {
  render() {
    return (
      <div class="ciTemplate">
        <div class="ciTemplate-text-content">
          <h1 class="ciTemplate-heading">
            Great Designs <br /> Every Time
          </h1>
          <span class="ciTemplate-subHeading">
            Our customizable design templates <br /> make it easy to kickstart your idea.
          </span>
          <ci-button variant="primary" href={`${process.env.CI_HOSTNAME}/inspiration`} onClick={() => trackEvent('templates', 'Explore Templates')}>
            Explore Templates
          </ci-button>
        </div>
      </div>
    );
  }
}
